// The wizard step keys these deferred signer tasks defer to. Must match the BE TpoStepRegistry keys
// (PascalCase) carried in the task's metadata.stepKey — see SetTpoApplicationSignersCommandHandler.
export const SignerStepKey = {
  ATTESTATION: 'Attestation',
  COMPENSATION_PLANS: 'CompensationPlans',
  QUESTIONNAIRE: 'Questionnaire',
};

// pathToEntity is empty for whole-step writes — the BE WriteStepDataAsync routes by stepKey via the
// TpoStepRegistry (mirrors saveIframeStepData's default ''), so the signer write does the same.
export const STEP_PATH_TO_ENTITY = '';

// Mirrors the TPO Signup wizard's CompensationPlans COMPENSATION_TYPES (BorrowerPaid / LenderPaid /
// Both) so the signer picks the same enum the filler would have.
export const COMPENSATION_TYPE_OPTIONS = [
  { value: 'BorrowerPaid', label: 'Borrower Paid' },
  { value: 'LenderPaid', label: 'Lender Paid' },
  { value: 'Both', label: 'Both' },
];

const ATTESTATION_INTRO_TEXT =
  'As the authorized signer, review the attestation below and confirm it on behalf of your company.';

const COMPENSATION_INTRO_TEXT =
  'As the authorized signer, review and complete the compensation plan on behalf of your company. ' +
  'Completing this step replaces the compensation plan submitted during certification, ' +
  'including any state-specific terms you remove here.';

const QUESTIONNAIRE_INTRO_TEXT =
  'As the authorized signer, review the answers below and correct anything that is wrong before ' +
  'confirming them on behalf of your company.';

export const STEP_INTRO_TEXT_BY_STEP_KEY = {
  [SignerStepKey.ATTESTATION]: ATTESTATION_INTRO_TEXT,
  [SignerStepKey.COMPENSATION_PLANS]: COMPENSATION_INTRO_TEXT,
  [SignerStepKey.QUESTIONNAIRE]: QUESTIONNAIRE_INTRO_TEXT,
};

export const DEFAULT_ATTESTATION_BODY_TEXT =
  'I attest that the information provided in this certification is true, complete, and accurate to ' +
  'the best of my knowledge, and that I am authorized to make this attestation on behalf of my company.';

export const STEP_COMPLETE_MISSING_CERTIFICATION_ERROR =
  'This task is missing its certification reference and cannot be completed here.';

export const STEP_COMPLETE_MISSING_STEP_INSTANCE_ERROR =
  'This task is missing its questionnaire reference and cannot be completed here.';

export const QUESTIONNAIRE_INVALID_ERROR =
  'Some answers need attention. Review the highlighted questions and try again.';

export const STEP_COMPLETE_UNSUPPORTED_STEP_ERROR =
  'This task references a step that cannot be completed here.';

export const STEP_COMPLETE_LOAD_ERROR = 'Unable to load this step. Please try again.';

export const STEP_COMPLETE_SUBMIT_ERROR = 'Unable to complete this step. Please try again.';

export const STEP_COMPLETE_NOT_SIGNER_ERROR =
  'Only the authorized signer for this certification can complete this step. Please contact the lender if you believe this is a mistake.';

export const STEP_COMPLETE_SUCCESS_MESSAGE = 'Step completed.';

export const ATTESTATION_CONFIRM_LABEL =
  'I confirm this attestation on behalf of my company as the authorized signer.';

export const ATTESTATION_NAME_REQUIRED_ERROR = 'Enter your full name to attest.';

export const ATTESTATION_CONFIRM_REQUIRED_ERROR = 'Confirm the attestation to continue.';

export const COMPENSATION_TYPE_REQUIRED_ERROR = 'Select a preferred compensation type.';

export const COMPENSATION_TERMS_REQUIRED_ERROR =
  'Enter basis points for at least one Purchases or Refinances term, in Default Terms or a state.';

// Mirrors the wizard's BASIS_POINTS_MAX (TPO Signup compensationTerms.ts) so the signer can't
// exceed what the filler could enter.
export const COMPENSATION_BPS_MAX = 10000;

export const COMPENSATION_BPS_MAX_ERROR = `Basis points must be at most ${COMPENSATION_BPS_MAX}.`;

export const COMPENSATION_NEGATIVE_AMOUNT_ERROR = 'Floor and Ceiling must be 0 or greater.';

export const getPurposeMissingBpsError = (groupLabel, purposeLabel) =>
  `Enter basis points for ${groupLabel} ${purposeLabel}, or clear its Floor and Ceiling.`;

// Fragment of the BE optimistic-concurrency 409 text (TpoCompanyProfileAdminController.CompleteSignerStep).
export const STALE_WRITE_CONFLICT_MARKER = 'modified by another writer';

export const STEP_CHANGED_ERROR =
  'This step was changed by someone else. Review the latest values and complete it again.';

export const getStateTermsMissingBpsError = stateCode =>
  `Enter basis points for ${stateCode} (Purchases or Refinances), or remove ${stateCode}.`;
